import { StudioTrialModalController } from './StudioTrialModal.controller';
import template from './StudioTrialModal.view.html';
export default (params) => {
    return {
        template,
        controller: StudioTrialModalController,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            confirm: params.confirm,
        },
    };
};
